export const LOW_METERED = 'low_metered'
export const HIGH_METERED = 'high_metered'
export const CUSTOM_METERED = 'custom_metered'

export const PLAN_DESCRIPTIONS = {
  [LOW_METERED]: 'Standard',
  [HIGH_METERED]: 'Pro',
  [CUSTOM_METERED]: 'Custom'
}
